/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BotExamLangTranslationOptionViewModel } from "../types/BotExamLangTranslationOptionViewModel.ts";

export const botExamLangTranslationOptionViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID da alternativa da questão.")),
  originalLabel: z
    .string()
    .describe(
      "Texto original da alternativa gerado pelo bot (pt-BR). Opcional.",
    )
    .nullish(),
  label: z
    .string()
    .describe("Texto da alternativa traduzida para o idioma alvo. Opcional.")
    .nullish(),
  isCorrect: z.optional(
    z.boolean().describe("Indica se esta alternativa é a correta."),
  ),
}) as unknown as ToZod<BotExamLangTranslationOptionViewModel>;
